import SingleProthesmia from "./SingleProthesmia";

const ProthesmiaCard = ({ input, proth }) => {
  return (
    <section className="prothesmies_section">
      {" "}
      {input !== "" &&
        proth
          .filter((r) => r?.prothesmia)
          .map((r, i) => <SingleProthesmia key={r.eidos} proth={r} />)}
    </section>
  );
};

export default ProthesmiaCard;
